<template>
  <a-modal
    title="添加计划时间"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 上课周期 -->
      <a-form-item
        label="上课周期"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          placeholder="请选择"
          v-decorator="['classWeeks', { rules: [{ required: true, message: '请选择' }] }]"
        >
          <a-select-option v-for="(item, index) in classWeekList" :key="index" :value="item">{{
            item | weekName
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 开班结班时间 -->
      <a-form-item
        label="上课时间"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          placeholder="请选择"
          v-decorator="['classTime', { rules: [{ required: true, message: '请选择' }] }]"
        >
          <a-select-option
            v-for="(item, index) in toClassList"
            :key="index"
            :value="item.startTime + '-' + item.endTime"
            >{{ item.startTime }} ~ {{ item.endTime }}</a-select-option
          >
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import course from '../../api/course'

import education from '../../api/education'

import { getDateDay } from '../../utils/date'

import moment from 'moment'

import Vue from 'vue'

export default {
  name: 'termFormModal',
  props: ['teachingPlan'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),

      classWeekList: [], //上课周期
      toClassList: [], //上课时间段
    }
  },
  methods: {
    moment,
    //初始化，显示
    init(params, intervalTime) {
      this.visible = true
      this.getClassTimeList(params.teachingTime, intervalTime)
      this.initClassWeek(params.classWeeks)
      setTimeout(() => {
        this.form.resetFields()
      }, 1)
    },

    //查询时间间隔
    getInterval(classTime) {
      const classTimeList = classTime.split('-')
      let res = ''
      this.toClassList.map(item => {
        if (item.startTime == classTimeList[0] && item.endTime == classTimeList[1]) {
          res = item.interval
        }
      })
      return res
    },

    //提交
    handleSubmit() {
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          if (this.teachingPlan.length == 40) {
            this.$message.error('上课计划最多设置40个')
          } else {
            const res = {
              classWeeks: value.classWeeks,
              classTime: value.classTime,
            }
            this.$emit('backTeachingPlan', {
              teachingPlan: res,
              interval: this.getInterval(value.classTime),
            })
            this.handleCancel()
          }
        }
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false
    },

    //获取选课时间的List
    getClassTimeList(value, intervalTime) {
      education.getClassTimeList().then(res => {
        // let teachingTimeList = value.split('-')
        // this.toClassList = res.data.filter(item=>{
        //   return item.interval >= teachingTimeList[0] && item.interval <= teachingTimeList[1] && (!intervalTime || intervalTime == item.interval)
        // });
        this.toClassList = res.data
      })
    },

    //初始化上课周期
    initClassWeek(value) {
      this.classWeekList = value.split(',')
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.person-scope {
  width: 100px;
  text-align: center;
  display: inline-block;
}
.max-person {
  border-left: none;
}
.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
</style>
